import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Layout, Menu, Row, Popover, Button } from "antd";
import { ClickParam } from "antd/lib/menu";
import { useMedia } from "react-use";

import { MdMenu } from "react-icons/md";
import * as actions from "../../actions";

import { getLanguageIcon } from "../../utils";
import { AuthState } from "../../reducers/auth";
import { LanguageState } from "../../reducers/language";
import { State } from "../../interfaces";

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const { Header } = Layout;
const logo = require("../../images/logo.png");

const Nav = () => {
  const language: LanguageState = useSelector(
    (state: State) => state.language,
    shallowEqual
  );
  const { entities, selectedLanguage, labels } = language;
  const auth: AuthState = useSelector(
    (state: State) => state.auth,
    shallowEqual
  );
  const { user, isFetching } = auth;

  const dispatch = useDispatch();
  const onLogout = useCallback(() => dispatch(actions.logout()), [dispatch]);
  const onSelectLanguage = useCallback(
    language => dispatch(actions.selectLanguage(language)),
    [dispatch]
  );
  const onHomeClicked = useCallback(() => dispatch(actions.getFilters()), [
    dispatch
  ]);

  const isSmall = useMedia("(max-width: 768px)");

  const handleClick = (param: ClickParam) => {
    if (param.key.includes("flag")) {
      const code = param.key.substr(5, 5);
      const language = entities.byId[code];
      onSelectLanguage(language);
    }
  };

  const languages = entities.all.map(_id => {
    const { id, name } = entities.byId[_id];
    return (
      <Menu.Item key={`flag:${id}`}>
        <div className="flag-wrapper">
          <img
            className="flag"
            src={`flags/${getLanguageIcon(id)}.png`}
            alt={name}
          />
          <span className="flag-name">{name}</span>
        </div>
      </Menu.Item>
    );
  });

  const welcome = labels ? labels.welcome : null;

  return (
    <Header className="main-nav">
      <Row justify="space-between" align="middle">
        <Link className="logo-link" to="/home" onClick={onHomeClicked}>
          <img src={logo} alt="" className="logo" />
        </Link>
        <div className="navbar">
          {user &&
            (isSmall ? (
              <p />
            ) : (
              <p className="welcome">
                {welcome} {user.firstName}
              </p>
            ))}
          {user && !user.portal && (
            <Button
              className="logout-button"
              onClick={() => onLogout()}
              loading={isFetching}
            >
              Log out
            </Button>
          )}
          {isSmall ? (
            // menu mobile
            <Popover
              overlayClassName="popover-menu-mobile"
              placement="bottomRight"
              // getPopupContainer={triggerNode => triggerNode.parentNode  as HTMLElement}
              content={
                <Menu className="menu-mobile" onClick={handleClick}>
                  {selectedLanguage && (
                    <MenuItemGroup key="l1" title="Languages">
                      {languages.map(item => item)}
                    </MenuItemGroup>
                  )}
                </Menu>
              }
              trigger="click"
            >
              <Button className="menu-btn">
                <MdMenu />
              </Button>
            </Popover>
          ) : (
            // menu desktop
            <Menu
              className="menu"
              theme="light"
              mode="horizontal"
              onClick={handleClick}
            >
              {selectedLanguage && (
                <SubMenu
                  title={
                    <div className="flag-wrapper">
                      <img
                        className="flag"
                        src={`/flags/${getLanguageIcon(
                          selectedLanguage.id
                        )}.png`}
                        alt={selectedLanguage.name}
                      />
                    </div>
                  }
                >
                  {languages.map(item => item)}
                </SubMenu>
              )}
            </Menu>
          )}
        </div>
      </Row>
    </Header>
  );
};

export default Nav;
